import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { Spin, Tag, Table, Modal, message } from 'antd';
import { Urls } from 'kts-platform-frame/entry/constant';
import { history } from 'kts-platform-frame/routes';
import {SettlementState} from './Modules.Constant';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { inputSettlement } from 'src/api';

const { formatTime, formatDate } = Field;
/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))

export default class extends UIBasic<IProps, ModulesState> {
    public noticeId = [];
    public columns = [
        {
            title: '单号',
            dataIndex: 'bizNoticeId',
            width: 120,
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '销方名称',
            dataIndex: 'supplierName',
            width: 210,
            className: 'text-left',
            render: (text, record) => {
                return <div>{text}</div>;
            }
        },
        {
            title: '日期',
            dataIndex: 'createTime',
            className: 'text-left',
            width: 130,
            render: (text, record) => {
                return (
                    <span>
                        {formatTime(record.createTime)}
                    </span>
                );
            }
        },
        {
            title: '金额',
            dataIndex: 'amountWithoutTax',
            className: 'text-right operate-column',
            width: 150,
            render: (text, record) => {
                return <span> {Field.formatMoney(text, 2)} </span>;
            }
        },
        {
            title: '税额',
            dataIndex: 'amountTax',
            className: 'text-right',
            width: 150,
            render: (text, record) => {
                return <span> {Field.formatMoney(text, 2)} </span>;
            }
        },
        {
            title: '价税合计',
            dataIndex: 'amountSum',
            className: 'text-right operate-column',
            width: 150,
            render: (text, record) => {
                return <span> {Field.formatMoney(record.amountSum, 2)} </span>;
            }
        },
        {
            title: '状态',
            dataIndex: 'billMatchState',
            className: 'text-center',
            width: 220,
            render: (text, record) => {
                return (
                    <span> {this.getMatchState(text)} {this.getBillState(record.noticeBillState)}</span>

                );
            }
        },
        {
            title: '匹配差异',
            dataIndex: 'amountMatchedTolerance',
            className: 'text-right operate-column',
            width: 130,
            render: (text, record) => {
                return (
                    <div>
                        {record.billMatchState !== 'NOTMATCH' && record.noticeBillState !== 'INVALID' ? (
                            <span>
                                {Field.formatMoney(record.amountMatchedTolerance, 2)}
                            </span>
                        ) : (
                                <span> - </span>
                            )}
                    </div>
                );
            }
        },
        {
            title: '税差',
            dataIndex: 'amountMatchedTaxTolerance',
            className: 'text-right operate-column',
            width: 130,
            render: (text, record) => {
                return (
                    <div>
                        {record.billMatchState !== 'NOTMATCH' && record.noticeBillState !== 'INVALID' ? (
                            <span>
                                {Field.formatMoney(record.amountMatchedTaxTolerance, 2)}
                            </span>
                        ) : (
                                <span> - </span>
                            )}
                    </div>
                );
            }
        },
        {
            title: '操作',
            dataIndex: 'operation',
            className: 'text-right operate-column',
            width: 210,
            render: (text, record) => {
                return (
                    <div>
                        {
                           // Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.GET_notice_income_id) &&
                            <span 
                                className="click-item" 
                                // onClick={() => this.onDetail(record.noticeId)} 
                                onClick={() => {
                                    this.onDetail(record.noticeId);
                                }}
                            >
                                详情
                            </span>
                        }
                        {record.billMatchState !== 'MATCHFINISH' ? (
                            record.noticeBillState !== 'INVALID' &&
                                record.noticeBillState !== 'REFUSED' ? (
                                    <span
                                        className="click-item"
                                        onClick={() =>
                                            this.onMatch(record.noticeId)
                                        }
                                    >
                                        <span className="vertical-line">|</span>
                                        匹配发票
                                    </span>
                                ) : null
                        ) : record.noticeBillState !== 'INVALID' ? (
                            <span
                                className="click-item"
                                onClick={() =>
                                    this.onViewMatch(record.noticeId)
                                }
                            >
                                <span className="vertical-line">|</span>
                                查看匹配
                            </span>
                        ) : null}
                        {record.noticeBillState === 'CREATED' &&
                            <span>
                                {
                                   // Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_income_batchSend) && 
                                    <span
                                        className="click-item"
                                        onClick={() => ModulesAction.handleSend(record.noticeId)}
                                    >
                                        <span className="vertical-line">|</span>
                                        发送
                                    </span>
                                }
                            </span>
                        }
                        {record.noticeBillState === 'REFUSED' &&
                            <span>
                                {
                                    //Lib.Util.UI.menuToggle(_menu, Lib.Util.Rule.POST_notice_income_batchInvalid) &&
                                    <span
                                        className="click-item"
                                        onClick={() =>
                                            this.toInvalid(record.noticeId)
                                        }
                                    >
                                        <span className="vertical-line">|</span>
                                        作废
                                    </span>
                                }
                            </span>
                        }
                    </div>
                );
            }
        }
    ];


    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    public  getBillState = (data: SettlementState): JSX.Element => {
        if (data === SettlementState.已创建) {
            return <Tag color="green">已创建</Tag>;
        } else if (data === SettlementState.已发送) {
            return <Tag color="green">已发送</Tag>;
        } else if (data === SettlementState.已接受) {
            return <Tag color="green">已接受</Tag>;
        } else if (data === SettlementState.已拒绝) {
            return <Tag color="red">已拒绝</Tag>;
        } else if (data === SettlementState.已作废) {
            return <Tag color="red">已作废</Tag>;
        }
        return <Tag color="red">'无可识别类型'</Tag>;
    }
    public getMatchState = (data: SettlementState): JSX.Element => {
        if (data === SettlementState.匹配中) {
            return <Tag color="green">匹配中</Tag>;
        }
        if (data === SettlementState.未匹配) {
            return <Tag color="orange">未匹配</Tag>;
        }
        if (data === SettlementState.已匹配) {
            return <Tag color="green">已匹配</Tag>;
        }
        return <Tag color="red">'无可识别类型'</Tag>;
    }
    public toInvalid = (id: number) => {
        Modal.confirm({
            title: '提示',
            content: '确认作废此结算单吗?',
            onOk: async() => {
                const result = await inputSettlement.invalid(this,[id]);
                ModulesAction.handleResult(result);
            }
        });

    }
    public onDetail = (id: number) => {
        history.push(`/workbench/inputSettlement/detail/${id}`);
    }

    public onViewMatch = (id: number) => {
        history.push(`/workbench/inputSettlement/viewMatch/${id}`);
    }
    public onMatch = (id: number) => {
        history.push(`/workbench/inputSettlement/match/${id}`);
    }
   
    componentDidMount () {
        const { user } = MyStore.instance.getState();
        const companyId = user.userInfo.companyId;
        console.log('mounted:', this.modulesState.pageMeta && this.modulesState.current);
        ModulesAction.initPaging();
        if (this.modulesState.fields){
            ModulesAction.getList({companyId,pageSize:10, pageNum: this.modulesState.current, ...this.modulesState.fields});
        } else {
            ModulesAction.getList({companyId,pageSize:10, pageNum: this.modulesState.current});
        }
    }
    
    render() {
        const {loadingUrls} = this.props;
        // console.log('render:', this.modulesState.receiptList);
        // const attr = {
        //     pagination: {
        //         current: this.modulesState.current,
        //         pageSize: this.modulesState.pageSize,
        //         pages: this.modulesState.receiptList && this.modulesState.receiptList.pageMeta.pages,
        //         total: this.modulesState.receiptList && this.modulesState.receiptList.pageMeta.total,
        //         onChange: ModulesAction.onPageChange,
        //     }
        // };
        const noticeId = [];
        const rowSelection = {
            onChange: (selectedRowKeys, selectedRows) => {
                console.log(selectedRows);
                console.log(selectedRowKeys);
                noticeId.length = 0;
                for (var i = 0; i < selectedRows.length; i++) {
                    noticeId.push(selectedRows[i]['noticeId']);
                }
                ModulesAction.setSelectKeys(noticeId);
            },
            selectedRowKeys: this.modulesState.selectedRowKeys
        };
        return (
            <div>
                <Spin spinning={loadingUrls.size > 0}>
                    <Table 
                        dataSource={this.modulesState.receiptList}
                        columns={this.columns}
                        rowKey={item=>item.noticeId}
                        rowSelection={rowSelection}
                        scroll={{ x: 1000 }}
                        pagination={{
                            onChange: ModulesAction.onPageChange, 
                            defaultPageSize: 10, 
                            total: this.modulesState.pageMeta && this.modulesState.pageMeta.total, 
                            current: this.modulesState.current
                        }}
                    />
                </Spin>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/UI.List.Table.tsx